import type * as ec from '@attain-apps/fe/web/main/lib/entity-collection'
import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type * as agentAssignment from '../agent-assignment'
import type * as contexts from '../contexts'

import type { TypeParams } from './types'

export const setFilters = store.effects.create(
  (
    feature: ec.Collection<TypeParams>['feature'],
    ec: ec.Collection<TypeParams>,
    contexts: contexts.Feature,
  ) =>
    contexts.selectors.activeEntityContext.asObservable.pipe(
      rxjs.debounceTime(500),
      rxjs.map(context =>
        ec.plugins.currentListPlugin.appliedParams.actions.setFilters
          .from('setFilters (effect)')
          .create(context),
      ),
    ),
)

export const refreshOnAgentAssignmentSuccess = store.effects.create(
  (
    feature: ec.Collection<TypeParams>['feature'],
    ec: ec.Collection<TypeParams>,
    agentAssignmentFeature: agentAssignment.Feature,
  ) =>
    agentAssignmentFeature.actions.assignAgentAccess.success.observe().pipe(
      rxjs.debounceTime(500),
      rxjs.map(() =>
        ec.plugins.currentListPlugin.feature.actions.load
          .from('refreshOnAgentAssignmentSuccess (effect)')
          .create(),
      ),
    ),
)
